import { render, staticRenderFns } from "./PopAgreement.vue?vue&type=template&id=0f8b2a3a"
import script from "./PopAgreement.vue?vue&type=script&lang=js"
export * from "./PopAgreement.vue?vue&type=script&lang=js"
import style0 from "./PopAgreement.vue?vue&type=style&index=0&id=0f8b2a3a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports